import 'css-chunksrc/client/scenes/attachDocuments/sideBar/styles.scss';export default {
  "navbar": "_navbar_13vvk_1",
  "link": "_link_13vvk_8",
  "isActive": "_isActive_13vvk_19",
  "icon": "_icon_13vvk_22"
};